import React, { useState, useEffect } from "react";
import { Alert } from "reactstrap";
import axios from "axios";
import moment from "moment";
import IntlMessages from "../../helpers/IntlMessages";

const getMeta = metaName => {
  if (document) {
    const metas = document.getElementsByTagName("meta");

    for (let i = 0; i < metas.length; i += 1) {
      if (metas[i].getAttribute("name") === metaName) {
        return metas[i].getAttribute("content");
      }
    }
  }
  return "";
};

const VersionChecker = props => {
  const [oldVersion, setOldVersion] = useState(false);
  const currentVersion = getMeta("app-version");
  const s3bucket = window.location.hostname
    .split(".")
    .slice(1)
    .join(".")
    .split("-local")[0];
  useEffect(() => {
    setInterval(async () => {
      const { data } = await axios.get(`https://s3.eu-west-1.amazonaws.com/${s3bucket}/version.txt`);
      if (data.length > 5 && data.trim() !== currentVersion && currentVersion !== "%VERSION%" && moment() <= moment(data.slice(0, 6), "DDMMYY")) {
        setOldVersion(true);
      }
    }, 10 * 60 * 1000);
  }, []);

  return (
    oldVersion && (
      <Alert
        color="warning"
        className="alert-heading fixed-top"
        style={{ zIndex: 9999999, position: "fixed" }}
        onClick={() => window.location.reload()}
      >
        <IntlMessages id="Your version is old. Please refresh your browser to reload!" />
      </Alert>
    )
  );
};

export default VersionChecker;
